import { axiosGet, axiosPost, axiosPostFormUrlencoded, axiosPut, axiosDelete } from "./ajaxServices";
import {
  urlGetAudienceList,
  urlCreateAudience,
  urlUpdateAudience,
  urlDeleteAudience,
  urlRegistrationList,
  urlGetPrograms,
} from "./CONSTANTS";

export async function fetchAudienceList(token) {
  // API requires POST with form-urlencoded token
  const params = new URLSearchParams();
  params.append("token", token);
  const res = await axiosPost(
    urlGetAudienceList,
    params,
    "Failed to load audience list"
  );
  // Expected: array of { id, name, created_date, email_count, emails }
  return Array.isArray(res) ? res : [];
}

// payload shape expected by backend:
// { token: string, audience_name: string, type: 1|2|3, emails?: string[], search_string?: string }
// Backend expects application/x-www-form-urlencoded format
export async function createAudience(payload) {
  // If emails is an array, the API expects a JSON array for emails — send as application/json
  if (payload && Array.isArray(payload.emails)) {
    return await axiosPost(urlCreateAudience, payload, "Failed to create audience");
  }
  return await axiosPostFormUrlencoded(urlCreateAudience, payload, "Failed to create audience");
}

// payload: { token, audience_id, audience_name, type, emails? }
// Backend expects application/x-www-form-urlencoded format
export async function updateAudience(payload) {
  // For edits, if emails provided as array, send JSON so backend receives an array
  if (payload && Array.isArray(payload.emails)) {
    return await axiosPost(urlUpdateAudience, payload, "Failed to update audience");
  }
  return await axiosPostFormUrlencoded(urlUpdateAudience, payload, "Failed to update audience");
}

export async function deleteAudience(params) {
  // params: { token, id }
  if (!params || typeof params !== 'object') {
    throw new Error('deleteAudience: params object is required');
  }
  const { token, id } = params;
  if (!token) {
    throw new Error('deleteAudience: missing admin token');
  }
  if (id === undefined || id === null) {
    throw new Error('deleteAudience: missing id of audience to delete');
  }
  const formParams = new URLSearchParams();
  formParams.append("token", token);
  formParams.append("id", id);
  return await axiosPost(urlDeleteAudience, formParams, "Failed to delete audience");
}

// Registration and Program helpers for modal
export async function fetchRegistrations(token, clubId) {
  // Ensure required parameters are present per API contract: token and club_id
  if (!token) {
    throw new Error("fetchRegistrations: missing admin token");
  }
  if (!clubId && clubId !== 0) {
    // clubId 0 is unlikely but allow numeric 0 explicitly; otherwise require truthy id
    throw new Error("fetchRegistrations: missing clubId (club_id required by API)");
  }

  // returns array of { id, name }
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("club_id", clubId);
  const res = await axiosPost(
    urlRegistrationList,
    params,
    "Failed to load registrations"
  );
  return Array.isArray(res) ? res : [];
}

export async function fetchPrograms(token, registrationId) {
  // returns array of program names for given registration
  // Validate required parameters according to API: token and registration_id are required
  if (!token) {
    throw new Error("fetchPrograms: missing admin token");
  }
  // registrationId must be a valid numeric id
  const numId = Number(registrationId);
  if (!registrationId && registrationId !== 0) {
    throw new Error("fetchPrograms: missing registrationId (registration_id required by API)");
  }
  if (Number.isNaN(numId) || !isFinite(numId)) {
    throw new Error("fetchPrograms: registrationId must be a valid numeric ID");
  }

  const params = new URLSearchParams();
  params.append("token", token);
  params.append("registration_id", registrationId);
  const res = await axiosPost(
    urlGetPrograms,
    params,
    "Failed to load programs"
  );
  return Array.isArray(res) ? res : [];
}


